import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=a2d5660e&scoped=true&"
var script = {}
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=a2d5660e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d5660e",
  null
  
)

export default component.exports